import React, { useEffect, useState } from 'react'
import CustomTooltip from '../../../CustomComponents/CustomTooltip'
import logFirebaseEvents from '../../../LogFirebaseEvents'
import { appTheme } from '../../../../helpers/utils/Utils'
import { useSelector } from 'react-redux'
import redAlert from '../../../../assets/images/red_alert.png'

const NotificationConfigureTableItem = ({ notificationSettingItem, updateConfigObjectByAlertCode, isReset , categoryShowFlags}) => {
    // debugger;
    const { AlertCode, Category, Description, Email, SMS, PushNotification, Title, CanOptInToEmail, CanOptInToSMS, CanOptInToPush } = notificationSettingItem;
    const [notificationSettings, setNotificationSettings] = useState(
        {
            "Email": Email,
            "SMS": SMS,
            "PushNotification": PushNotification
        });

    useEffect(() => {
        setNotificationSettings({
            "Email": Email,
            "SMS": SMS,
            "PushNotification": PushNotification
        })
    }, [isReset])
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);

    const handleEmailClick = () => {
        if (!CanOptInToEmail) return;
        logFirebaseEvents("Configure_Notification", "Email_Notification_Clicked", "Email_Notification_Clicked", "","")
        const updatedSettings = { ...notificationSettings, "Email": !notificationSettings.Email };
        setNotificationSettings(updatedSettings);
        updateConfigObjectByAlertCode(AlertCode, updatedSettings);
    }
    const handleSMSClick = () => {
        if (!CanOptInToSMS) return;
        logFirebaseEvents("Configure_Notification", "Text_Notification_Clicked", "Text_Notification_Clicked", "","")
        const updatedSettings = { ...notificationSettings, "SMS": !notificationSettings.SMS };
        setNotificationSettings(updatedSettings);
        updateConfigObjectByAlertCode(AlertCode, updatedSettings);
    }
   
    const handlePushClick = () => {
        if (!CanOptInToPush) return;
        logFirebaseEvents("Configure_Notification", "Push_Notification_Clicked", "Push_Notification_Clicked", "","")
        const updatedSettings = { ...notificationSettings, "PushNotification": !notificationSettings.PushNotification };
        setNotificationSettings(updatedSettings);
        updateConfigObjectByAlertCode(AlertCode, updatedSettings);
    }



    return (
        <div className=' flex flex-row justify-between w-full'> 
            <div className=' w-[60%]'>
                 <div className='flex items-center gap-8'>
                    <p className='font-hanken-grotesk font-[500] text-[13px] leading-[19px] sm:font-[500] sm:text-[12px] sm:leading-[18px] md:font-[500] md:text-[16px] md:leading-[24px] text-[var(--notifyTableContent)]'>{Title}</p>
                    {Category === "Mandatory" && !notificationSettings.Email && !notificationSettings.SMS && !notificationSettings.PushNotification && (
                        <img src={redAlert} alt="Mandatory notification" className="w-10 h-10" />
                    )}
                </div>
            </div>
            <div className=' flex flex-row justify-between items-center w-[40%]'>

                {Description ?
                    <CustomTooltip text={Description}>
                        <img src={appThemeData.customToolsToSee} alt="Image" class="" />
                    </CustomTooltip>
                    :
                    <div className='h-[20px] w-[23px]' />
                }
                {/* Push Notification */}
               {categoryShowFlags?.ShowPush && (
                    <button
                        onClick={handlePushClick}
                        className={`${!CanOptInToPush ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                        disabled={!CanOptInToPush}
                        title={!CanOptInToPush ? 'Push notifications not available' : ''}
                    >
                        {notificationSettings.PushNotification && CanOptInToPush ?
                            <div>
                                <img src={appThemeData.customCheckBoxToSee} alt='push notification enabled' />
                            </div>
                            :
                            <div>
                                <img src={appThemeData.customCheckBoxLightToSee} alt='push notification disabled' />
                            </div>
                        }
                    </button>
                )}








                {/* Email Notification */}
                {categoryShowFlags?.ShowEmail && (
                    <button
                        onClick={handleEmailClick}
                        className={`${!CanOptInToEmail ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                        disabled={!CanOptInToEmail}
                        title={!CanOptInToEmail ? 'Email notifications not available' : ''}
                    >
                        {notificationSettings.Email && CanOptInToEmail ?
                            <div>
                                <img src={appThemeData.customCheckBoxToSee} alt='email notification enabled' />
                            </div>
                            :
                            <div>
                                <img src={appThemeData.customCheckBoxLightToSee} alt='email notification disabled' />
                            </div>
                        }
                    </button>
                )}








                {/* SMS Notification */}
                {categoryShowFlags?.ShowSMS && (
                    <button
                        onClick={handleSMSClick}
                        className={`${!CanOptInToSMS ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                        disabled={!CanOptInToSMS}
                        title={!CanOptInToSMS ? 'SMS notifications not available' : ''}
                    >
                        {notificationSettings.SMS && CanOptInToSMS ?
                            <div>
                                <img src={appThemeData.customCheckBoxToSee} alt='sms notification enabled' />
                            </div>
                            :
                            <div>
                                <img src={appThemeData.customCheckBoxLightToSee} alt='sms notification disabled' />
                            </div>
                        }
                    </button>
                )}

                    
            </div>
        </div >
    )
}

export default NotificationConfigureTableItem













